import React, { Fragment } from 'react';
import { getSRRIByValue } from '@finect/front-resources/RiskProfile';
export var RiskProfile = function RiskProfile(_ref) {
  var product = _ref.product;
  var riskProfile = getSRRIByValue(product.entity.srri);
  if (!riskProfile) {
    return 'nada';
  }
  return React.createElement(Fragment, null, riskProfile.label);
};